import * as React from 'react';
import { Component } from 'react';
import { IClinicListItem } from '../../models/IClinicListItem';
import './ClinicList.css';
import { ClinicListItemComponent } from './ClinicListItem';

interface IProps {
    Items: IClinicListItem[],
    OnRefreshRequired: () => void,
    PhysiotherapistId?: string,
    ShowClinicOnMap?: (clinic: IClinicListItem) => void
}

export class ClinicListComponent extends Component<IProps, any> {
    constructor(props) {
        super(props);
    }

    public render() {
        return (
            <div className="clinic-list-component">
                {this.RenderListItems()}           
            </div>
        );
    }

    public RenderListItems() {
        if (this.props.Items === undefined) {
            return (
                <label>(brak)</label>
            );
        }
        if (this.props.Items.length === 0) {
            return (
                <label>(brak)</label>
            );
        }
        let resultItems: JSX.Element[] = [];
        let teleItem = this.props.Items.find((clinic) => (clinic.IsTele === true));
        let homeServiceItem = this.props.Items.find((clinic) => (clinic.IsHomeService === true));
        if (teleItem) {
            resultItems.push((
                <ClinicListItemComponent
                    key={teleItem.Id}
                    PhysiotherapistId={this.props.PhysiotherapistId}
                    OnRefreshRequired={this.props.OnRefreshRequired}
                    Item={teleItem}
                    IsFirst={false}
                    IsTele={true}
                    IsHomeService={false}
                    ShowClinicOnMap={this.props.ShowClinicOnMap} />
            ));
        }

        if (homeServiceItem) {
            resultItems.push((
                <ClinicListItemComponent
                    key={homeServiceItem.Id}
                    PhysiotherapistId={this.props.PhysiotherapistId}
                    OnRefreshRequired={this.props.OnRefreshRequired}
                    Item={homeServiceItem}
                    IsFirst={false}
                    IsTele={false}
                    IsHomeService={true}
                    ShowClinicOnMap={this.props.ShowClinicOnMap} />
            ));
        }

        let standardItems = this.props.Items.filter((clinic) => (clinic.IsTele !== true && clinic.IsHomeService !== true));
        let firstItem = true;
        for (let item of standardItems) {
            resultItems.push((
                <ClinicListItemComponent
                    key={item.Id}
                    PhysiotherapistId={this.props.PhysiotherapistId}
                    OnRefreshRequired={this.props.OnRefreshRequired}
                    Item={item}
                    IsFirst={firstItem}
                    IsTele={false}
                    IsHomeService={false}
                    ShowClinicOnMap={this.props.ShowClinicOnMap} />
            ));
            firstItem = false;
        }
        return (
            <ul className="light-list clinic-list">{resultItems}</ul>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Clinic/ClinicList.tsx